import { globals } from 'common-ui';

export const commerceApiExtraConfig = (publicCsrfValue = ''): { webApiExtraHeaders: { [key: string]: string } } => ({
  webApiExtraHeaders: {
    [globals.authAndWebApiCsrfHeaderName as string]: publicCsrfValue,
  },
});
